import React from 'react';
import { Skeleton as ChakraSkeleton, Box } from '@chakra-ui/react';

export const Skeleton = ({
    count,
    height = '8',
    my = '2'
}: {
    count: number;
    height?: string;
    my?: string;
}) => {
    return (
        <Box>
            {Array.from(Array(count), (_, i) => {
                return <ChakraSkeleton key={i} height={height} my={my} />;
            })}
        </Box>
    );
};
